
import React from "react";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  objectFit?: "contain" | "cover" | "fill" | "none" | "scale-down";
  rounded?: boolean;
}

const Image: React.FC<ImageProps> = ({ 
  objectFit = "contain", 
  rounded = false, 
  className = "", 
  ...props 
}) => {
  return (
    <img 
      className={`${rounded ? "rounded-full" : ""} ${objectFit ? `object-${objectFit}` : ""} ${className}`}
      {...props} 
    />
  );
};

export default Image;
